import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Импортируем JSON файлы
import ru from "./ru.json";
import en from "./en.json";
import es from "./es.json";
import zh from "./zh.json";
import fr from "./fr.json";

// Ресурсы для переводов
const resources = {
  ru: { translation: ru },
  en: { translation: en },
  es: { translation: es },
  zh: { translation: zh },
  fr: { translation: fr } 
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    
    // Языки которые поддерживаются
    supportedLngs: ["ru", "en", "es", "zh", "fr"],
    
    // Язык по умолчанию если не определился
    fallbackLng: "ru",
    
    // Загружаем только язык без региона (en-US -> en)
    load: "languageOnly",
    
    // Интерполяция
    interpolation: { 
      escapeValue: false 
    },
    
    // React настройки
    react: { 
      useSuspense: false 
    },

    // Детектор языка
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      
      // Ключ в localStorage
      lookupLocalStorage: "i18nextLng",
      
      // Параметр в URL
      lookupQuerystring: "lng"
    }
  });

export default i18n;
